<template>
  <div class="card-list" :class="{ 'with-background': isPurchaseCardPage }">
    <div class="card-list-container">
      <div
        class="bg-card"
        :class="{ 'one-sheet': oneSheet }"
        v-for="(cardItem, index) in normalizedCardList"
        :key="cardItem.id || index"
      >
        <div class="card-container">
          <div v-if="isSpecialItem(cardItem)" class="special-label">
            特価
          </div>
          <div class="image-area" :class="{ 'one-sheet': oneSheet }">
            <img
              class="card"
              :class="{ 'one-sheet': oneSheet, radius: isRadius(cardItem) }"
              :src="cardItem.image"
              :alt="cardItem.name"
            />
            <img v-if="cardItem.card_name && cardItem.card_name.toLowerCase().includes('psa') || cardItem.name && cardItem.name.toLowerCase().includes('psa')" class="psa-icon" src="/img/PSA.png">
          </div>
          <div class="info-box">
            <div class="name">{{ cardItem.name || cardItem.card_name }}</div>
            <div class="rarity">
              {{ cardItem.rarity || cardItem.card_rarity }}
            </div>
            <div class="model-number">
              {{ cardItem.model_number || cardItem.card_model_number }}
            </div>
          </div>
          <div class="bottom">
            <div class="price-box">
              <!-- 即決かつ売却額が存在しない場合 -->
              <div class="price" v-if="cardItem.sale_type == '0' && !cardItem.status == 1">
                {{ cardItem.price | comma }} {{ t('円') }}
              </div>
              <!-- オークションの場合 -->
              <div class="price" v-else-if="cardItem.sale_type == '1' && !cardItem.status == 1">
                {{ t('現在') }}
                <span v-if="cardItem.auction_price"
                >{{ cardItem.auction_price | comma }} {{ t('円') }}~</span
                >
                <span v-else>{{ cardItem.price | comma }} {{ t('円') }}~</span>
              </div>
              <!--売却済みかつマイリストの場合 -->
              <div class="price" v-else-if="isMyList && cardItem.status == 1">
                {{ t('出品額') }} {{ cardItem.price | comma }} {{ t('円') }}
                <br>
                {{ t('入金額') }} {{ cardItem.net_amount | comma }} {{ t('円') }}
              </div>
              <!--売却済みの場合 -->
              <div class="price" v-else-if="cardItem.status == 1">
                {{ cardItem.price | comma }} {{ t('円') }}
              </div>
              <!-- 販売中だけどガチャがまだ終了していなくて表示されていないものに表示 -->
              <div class="display-schedule" v-if="cardItem.show_list && isMyList && cardItem.status !== 1">
                {{ t('当該ガチャの販売終了後に自動で出品されます') }}
              </div>
              <div v-if="historyView">{{ cardItem.price | comma }} {{ t('円') }}</div>
            </div>
            <div class="auction" v-if="cardItem.sale_type == '1' && !oneSheet">
              <div class="auction-bid">
                <img
                  class="auction-icon"
                  src="/img/menu/gavel.png"
                  alt="ガベルのアイコン"
                />
                20
              </div>
              <div class="auction-time">
                <img
                  class="clock-icon"
                  src="/img/menu/clock.png"
                  alt="時計のアイコン"
                />
                {{ countdownStrMap[cardItem.id] }}
                <!-- 20時間 -->
              </div>
            </div>
            <div
              class="button-area"
              v-if="!hideButtons"
            >
              <div v-if="isType == 'undecided'">
                <!-- マイカート、未出品時 -->
                <BuyButton
                  :isArrow="false"
                  :isMini="true"
                  :text="t('販売価格を決める')"
                  @handleSquareBtnClick="handleSquareBtnClick(cardItem)"
                />
              </div>
              <!-- 自分の出品商品で未売却の場合の選択ボタン -->
              <div
                v-if="
                  (cardItem.id &&
                  effectiveCurrentUser &&
                  effectiveCurrentUser.id &&
                  String(cardItem.user_id) === String(effectiveCurrentUser.id) &&
                  (cardItem.status == 0 || cardItem.status === '0')) ||
                  (isType == 'undecided')
                  "
                class="market-choice-buttons"
                >
                <BuyButton
                  v-if="cardItem.status == 0"
                  :isArrow="false"
                  :isMini="true"
                  :text="t('価格を変更する')"
                  @handleSquareBtnClick="handlePriceChange(cardItem)"
                  class="choice-btn"
                />
                <BuyButton
                  :isArrow="false"
                  :isMini="true"
                  :text="t('コインに還元する')"
                  @handleSquareBtnClick="handleCoinChoice(cardItem)"
                  class="choice-btn"
                />
                <BuyButton
                  :isArrow="false"
                  :isMini="true"
                  :text="t('発送する')"
                  @handleSquareBtnClick="handleShippingChoice(cardItem)"
                  class="choice-btn"
                />
              </div>
              <!-- 出品者とログインユーザーが同じでない場合のみ表示 -->
              <div
                v-if="
                  !oneSheet &&
                    cardItem.id &&
                    countdownStrMap[cardItem.id] !== '終了' &&
                    cardItem.user_id != currentUser.id &&
                    !isMyList
                "
              >
                <div v-if="cardItem.sale_type == '0' && cardItem.status == 0">
                  <!-- 即決かつまだ期間内（出品して2週間経過していない） -->
                  <BuyButton
                    :isArrow="false"
                    :isMini="true"
                    :text="t('カートへ')"
                    @handleSquareBtnClick="handleSquareBtnClick(cardItem)"
                  />
                </div>
                <div v-if="cardItem.sale_type == '1' && cardItem.status == 0">
                  <!-- オークションかつまだ期間内（出品して2週間経過していない） -->
                  <BuyButton
                    :isArrow="false"
                    :isMini="true"
                    :text="t('入札する')"
                    @handleSquareBtnClick="handleSquareBtnClick(cardItem)"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="sold_out" v-if="cardItem.status == 1">
            <span>SOLD OUT</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 確認ダイアログ -->
    <CommonOverlay
      :isGray="true"
      class="overlay_conf"
      v-show="isOpenConfirm"
      @handleOverlayClick="closeConfirm"
    >
      <CommonModal class="modal pack-confirm">
        <div class="block">
          <div class="confirm-title">{{ t('確認') }}</div>
        </div>
        <div class="block">
          <div class="confirm-message">
            <span v-if="confirmType === 'coin'">
              <div class="coin-info">
                <img src="/img/star_coin.webp" alt="コインのアイコン" class="coin-icon">
                {{ confirmCardItem.reduction_point | comma }}
              </div>
              {{ t('このカードをコインに還元しますか？') }}<br />
              {{ t('(※実行後の変更はできません)') }}
            </span>
            <span v-else-if="confirmType === 'shipping'">
              {{ t('このカードを発送しますか？') }}<br />
              {{ t('(※実行後の変更はできません)') }}
            </span>
          </div>
        </div>
        <div class="modal-button-area">
          <SimpleButton
            class="purchase-btn"
            :isArrow="false"
            :text="t('はい')"
            @handleSquareBtnClick="executeAction"
          />
          <SimpleButton
            class="purchase-btn cancel-btn"
            :isArrow="false"
            :text="t('キャンセル')"
            @handleSquareBtnClick="closeConfirm"
          />
        </div>
      </CommonModal>
    </CommonOverlay>
  </div>
</template>

<script>
import { separateCharacterNumber } from '@/common/util/format';
import { mapGetters } from 'vuex';
import t from '@/plugins/i18n';
import BuyButton from '@/components/atoms/BuyButton.vue';
import CommonOverlay from '@/components/atoms/CommonOverlay.vue';
import CommonModal from '@/components/atoms/CommonModal.vue';
import SimpleButton from '@/components/atoms/SimpleButton.vue';

export default {
  name: 'MarketCardList',
  mixins: [t],

  components: {
    BuyButton,
    CommonOverlay,
    CommonModal,
    SimpleButton,
  },

  props: {
    cardList: {
      type: Array,
      default: () => [],
    },
    isHistory: {
      type: Boolean,
      default: false,
    },
    isType: {
      type: String,
      default: '',
    },
    oneSheet: {
      type: Boolean,
      default: false,
    },
    currentUser: {
      type: Object,
    },
    historyView: {
      type: Boolean,
      default: false,
    },
    isMyList: {
      type: Boolean,
      default: false,
    },
    hideButtons: {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    comma(value) {
      return separateCharacterNumber(value);
    },
  },

  data: () => ({
    countdownStr: '',
    countdownStrMap: {},
    timerIdMap: {},
    isOpenConfirm: false,
    confirmType: '', // 'coin' or 'shipping'
    confirmCardItem: null,
  }),

  computed: {
    ...mapGetters({
      choiceResult: 'market/market_choice',
      userFromStore: 'user/currentUser',
    }),
    // currentUserをpropsまたはstoreから取得
    effectiveCurrentUser() {
      return this.currentUser || this.userFromStore;
    },
    isPurchaseCardPage() {
      return this.$route.name === 'PurchaseCard';
    },
    normalizedCardList() {
      return Array.isArray(this.cardList) ? this.cardList : [];
    },
  },

  watch: {
    cardList: {
      immediate: true,
      handler(newList) {
        // タイマーをクリア
        Object.values(this.timerIdMap).forEach((id) => clearInterval(id));
        this.timerIdMap = {};
        this.countdownStrMap = {};
        newList
          .filter((cardItem) => !!cardItem?.id && (cardItem.sale_type === '1' || cardItem.sale_type === 1))
          .forEach((cardItem) => {
            this.setCountdownString(cardItem);
            const intervalId = setInterval(() => {
              this.setCountdownString(cardItem);
            }, 1000);
            this.$set(this.timerIdMap, cardItem.id, intervalId);
          });
      },
    },
  },
  methods: {
    // 既存のメソッド
    isSpecialItem(cardItem) {
      return this.isHistory && cardItem.is_tokka === 1;
    },
    isRadius(card) {
      const specialTypes = ['2', '3', '5'];
      const isBox = card.card_name?.includes('BOX');
      return specialTypes.includes(String(card.card_type)) && !isBox;
    },
    handleSquareBtnClick(cardItem) {
      if (this.isType === 'undecided') {
        this.$emit('handleBtnClick', cardItem);
      }
      if (cardItem.sale_type === '1' || cardItem.sale_type === 1) {
        this.$emit('handleBidClick', cardItem); // 入札
      } else {
        this.$emit('handleCartClick', cardItem); // カート
      }
    },
    // マーケット選択メソッド
    handleCoinChoice(cardItem) {
      this.openConfirm('coin', cardItem);
    },
    handleShippingChoice(cardItem) {
      this.openConfirm('shipping', cardItem);
    },
    handlePriceChange(cardItem) {
      this.$emit('handlePriceChange', cardItem);
    },
    // 確認ダイアログを開く
    openConfirm(type, cardItem) {
      this.confirmType = type;
      this.confirmCardItem = cardItem;
      this.isOpenConfirm = true;
    },
    // 確認ダイアログを閉じる
    closeConfirm() {
      this.isOpenConfirm = false;
      this.confirmType = '';
      this.confirmCardItem = null;
    },
    // 確認後の実際の処理実行
    executeAction() {
      if (!this.confirmCardItem) return;
      const choiceType = this.confirmType === 'coin' ? 1 : 2;
      const postParam = { choiceType };
      postParam.user_id = this.confirmCardItem.user_id;
      // 出品済みカードの場合はmarket_id、未出品カードの場合はuser_history_card_id
      if (this.confirmCardItem.id) {
        postParam.market_id = this.confirmCardItem.id;
      } else if (this.confirmCardItem.history_card_id) {
        postParam.user_history_card_id = this.confirmCardItem.history_card_id;
      } else {
        // fallback: cardItem.idがuser_history_card_idの場合
        postParam.user_history_card_id = this.confirmCardItem.id;
      }
      this.$store.dispatch('market/market_choice', {
        postParams: postParam,
      }).then(() => {
        this.closeConfirm();
        this.$emit('refreshList');
      }).catch((error) => {
        console.error('マーケット選択エラー:', error);
        this.closeConfirm();
      });
    },
    setCountdownString(cardItem) {
      const createdRaw = cardItem.created;
      if (!createdRaw) return;
      const startTime = new Date(createdRaw.replace(/-/g, '/'));
      startTime.setDate(startTime.getDate() + 14);
      const now = new Date();
      const diffMs = startTime - now;
      if (diffMs <= 0) {
        this.countdownStrMap[cardItem.id] = this.t('終了');
        clearInterval(this.timerIdMap[cardItem.id]);
        return;
      }
      const diffSeconds = Math.floor(diffMs / 1000);
      const diffMinutes = Math.floor(diffSeconds / 60);
      const diffHours = Math.floor(diffMinutes / 60);
      const diffDays = Math.floor(diffHours / 24);
      const lang = this.currentUser?.language || 'ja';
      let key;
      let value;

      if (diffSeconds < 60) {
        key = '%d秒';
        value = diffSeconds;
      } else if (diffMinutes < 60) {
        key = '%d分';
        value = diffMinutes;
      } else if (diffHours < 24) {
        key = '%d時間';
        value = diffHours;
      } else {
        key = '%d日';
        value = diffDays;
      }

      const template = this.i18n_message?.[key]?.[lang] || key;
      this.$set(
        this.countdownStrMap,
        cardItem.id,
        template.replace('%d', value),
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.card-list {
  max-width: 99%;
  margin: 0 auto;
}
.card-list-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  max-width: 725px;
  gap: 15px;
  margin: 0 auto;
  @media screen and (min-width: 1338px) {
    max-width: 1200px;
  }
  @media screen and (min-width: 1672px) {
    max-width: 1500px;
  }
}
.bg-card {
  width: 170px;
  background: linear-gradient(to right, #ffe600, #e60012);
  border-radius: 13px;
  padding: 2px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.7);
  margin: 10px 0;
  &.one-sheet {
    width: 230px;
  }
  .card-container {
    display: flex;
    position: relative;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
    background: white;
    border-radius: 10px;
    z-index: 0;
    .special-label {
      position: absolute;
      top: -25px;
      left: 0;
      background: white;
      color: #b71922;
      font-size: 16px;
      font-weight: bold;
      padding: 5px 20px;
      border-radius: 5px;
      border: 2px solid #b71922;
    }
    .image-area {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      padding: 10px;
      &.one-sheet {
        padding: 20px;
      }
      .card {
        width: 90%;
        min-width: 113px;
        transform: rotate(10deg);
        @media screen and (max-width: $tabletWidth) {
          width: 70px;
          min-width: 70px;
          &.one-sheet {
            width: 90px;
            min-width: 90px;
          }
        }
        &.radius {
          border-radius: 4px;
        }
      }
      .psa-icon{
        position: absolute;
        left: 5px;
        bottom: 20px;
        width: 60px;
      }
    }
    .info-box {
      display: flex;
      z-index: 1;
      flex-direction: column;
      align-items: center;
      border-radius: 4px;
      text-align: center;
      padding: 3px 0;
      background-color: white;
      width: 90%;
      box-shadow: 0 0 4px rgba(0, 0, 0, 0.7);
      margin-top: -15px;
      font-weight: bold;
      font-size: 12px;
      .name {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        max-height: calc(1.3em * 2);
        line-height: 1.1;
      }
      .rarity {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        max-height: calc(1.3em * 1);
        width: fit-content;
        min-width: 70%;
      }
      .model-number {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        max-height: calc(1.3em * 1);
      }
    }
    .bottom {
      margin-top: auto; // ← これでも固定されるが、すでに space-between なので不要な場合あり
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .price-box {
        text-align: center;
        font-weight: bold;
      }
      .display-schedule {
        font-size: 12px;
        color: $red;
        @media screen and (max-width: $tabletWidth) {
          font-size: 11px;
        }
      }
      .auction {
        display: flex;
        font-weight: bold;
        justify-content: space-between;
        width: 90%;
        .auction-bid {
          display: flex;
          width: 40%;
          background-color: #c2c2c2;
          box-shadow: 0 0 2px rgba(0, 0, 0, 0.7);
          align-items: center;
        }
        .auction-time {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 58%;
          color: $red;
        }
        img {
          width: 27px;
          height: auto;
        }
      }
      .button-area {
        padding: 5px;
        z-index: 1;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        width: 100%;
        .market-choice-buttons {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 8px;
          width: 100%;
          .choice-btn {
            width: 100%;
          }
        }
      }
    }
    .sold_out {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      padding-bottom: 0%;
      background-color: rgba(0, 0, 0, 0.2);
      display: flex;
      justify-content: center;
      align-items: center;
      color: $white;
      font-size: 45px;
      border-radius: 8px;
      z-index: 1;
      span {
        border-radius: 8px;
        padding: 5px 20px;
        font-weight: bold;
        transform: rotate(15deg);
        text-shadow: 4px 4px 4px rgba(0, 0, 0, 0.5);
      }
      @media screen and (max-width: $mobileWidth) {
        font-size: 30px;
      }
    }
  }
}
@media screen and (max-width: $tabletWidth) {
  .card-list-container {
    max-width: 490px;
    gap: 15px;
  }
  .bg-card {
    width: 150px;
    .card-container {
      .image-area {
        .psa-icon{
          left: 0px;
          bottom: 18px;
          width: 40px;
        }
      }
      .info-box {
        padding: 8px 2px;
        font-size: 10px;
      }
      .price {
        font-size: 16px;
      }
      .auction {
        font-size: 13px;
        img {
          width: 20px;
        }
      }
    }
  }
}
@media screen and (max-width: 500px) {
  .bg-card {
    width: calc(33.333% - 10px);
    .card-container {
      .info-box {
        padding: 4px 2px;
        .name {
          font-size: 8px;
        }
        .rarity {
          font-size: 8px;
        }
        .model-number {
          font-size: 8px;
        }
      }
      .price {
        font-size: 14px;
      }
      .auction {
        font-size: 10px;
        img {
          width: 20px;
        }
      }
    }
  }
}
// 確認ダイアログのスタイル
.overlay_conf {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  .modal.pack-confirm {
    border: none;
    box-shadow: 0 0px 20px rgba(0, 0, 0, 1.0);
    border-radius: 10px;
    width: 400px;
    max-height: 90%;
    overflow-y: auto;
    padding: 20px;
    position: relative;
    @media screen and (max-width: $tabletWidth) {
      width: 320px;
      margin: 0 auto;
    }
    .block {
      padding: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      font-weight: bold;
      text-align: center;
      .confirm-title {
        font-size: 20px;
        color: $black;
      }
      .confirm-message {
        font-size: 16px;
        color: $black;
        line-height: 1.5;
        .coin-info {
          justify-content: center;
          display: flex;
          align-items: center;
          font-size: 20px;
          .coin-icon {
            width: 45px;
            height: auto;
          }
        }
      }
    }
      .modal-button-area {
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
        gap: 30px;
        margin-top: 40px;
        .purchase-btn {
          width: 48%;
        }
        @media screen and (max-width: $mobileWidth) {
          flex-direction: column;
          margin: 40px 0;
          align-items: center;
          gap: 25px;
          .purchase-btn {
            width: 100%;
            max-width: 165px;
          }
        }
      }
  }
}
</style>
